import React, {useEffect, useState} from 'react';
import "./page.css"
import Loading from "../../component/loading/loading";
import {ENV} from "../../services/env";
import Layout from "../../component/layout/layout";
import {useHistory, useParams} from "react-router-dom";
import Api from "../../services/api";
import {toast} from "react-toastify";
const Page = () => {
    const [list , setList] = useState([])
    const [loading, setLoading] = useState(false)
    const param = useParams()
    useEffect(() => {
        getData()
        window.scrollTo({top:0 , behavior:"smooth"})
    } ,[param])


    console.log(param)
    const getData = () => {
        setLoading(true)
        new Api().get(`/post/${param.id}`)
            .then((res) => {
                setLoading(false)
                setList(res)
                window.scrollTo({top:0 , behavior:"smooth"})
            })
            .catch((err) => {
                setLoading(false)
                toast.error(err)
            })
    }

    return (
        <Layout>
            <div className={"container"}>
                <div className={"post"}>
                    {
                        loading ? <Loading /> :
                            <div className={"post-content"}>
                                <div  className={"post-title"}>
                                    <h2> {list.title}</h2>
                                </div>
                                {
                                    list.image &&
                                    <div className={"post-content-img"}>
                                        <img src={ENV.API.IMG + list.image}/>
                                    </div>
                                }
                                {
                                    list.description &&
                                    <div dangerouslySetInnerHTML={{__html:list.description}} className={"gallery-des"}/>
                                }
                            </div>
                    }
                </div>
            </div>
        </Layout>
    );
};

export default Page;